<template>
  <div>
    <!-- pc -->
    <div class="table_3">
      <div class="title">
        <span v-html="type">
          <!-- {{ cType }} -->
        </span>
        <a :href="link" v-html="title" target="_blank">
          <!-- {{ cTitle }} -->
        </a>
      </div>
      <div class="table" style="display:none;">
        <div class="row">
          <div class="block fl">
            <div
              class="sign fl"
              style="padding-right: 10px; width: 80px; text-align-last: justify"
            >
              文 号：
            </div>
            <div class="content fl" v-html="docno">
              <!-- {{ cWenHao }} -->
            </div>
          </div>
          <div class="block fl" style="border-right: none">
            <div class="sign fl">发布机构：</div>
            <div class="content fl" v-html="publisher">
              <!-- {{ cFaBuJiGou }} -->
            </div>
          </div>
        </div>
        <div class="clear"></div>
        <div class="row">
          <div class="block fl">
            <div class="sign fl">主题分类：</div>
            <div class="content fl" v-html="cdesc">
              <!-- {{ cZhuTiFenLei }} -->
            </div>
          </div>
          <div class="block fl" style="border-right: none">
            <div class="sign fl">公文时效:</div>
            <div class="content fl" v-html="validity">
              <!-- {{ cGongWenShiXiao }} -->
            </div>
          </div>
        </div>
        <div class="clear"></div>
        <div class="row2">
          <div class="sign fl" style="padding-right: 10px; width: 80px">
            摘 要：
          </div>
          <div class="content fl">
            <p v-html="zc_doccontent"></p>
          </div>
          <!-- {{ cZhaiYao }} -->
        </div>
      </div>
      <div class="info">
        <div class="department fl" style="margin-right: 5px">
          <a :href="link" v-html="sitedesc" target="_blank">
            <!-- {{ cBuMen }} -->
          </a>
        </div>
        <div class="date fl">
          <!-- {{ docpubtime | dataFormat }} -->
          {{ docpubtime.substring(0,10) }}
          <!-- <p v-html="cDate">
          {{ cDate }}
        </p> -->
        </div>
      </div>
    </div>
    <!-- mobile -->
    <div class="mobile">
      <div class="title">
        <span v-html="type">
          <!-- {{ cType }} -->
        </span>
        <a :href="link" v-html="title" target="_blank">
          <!-- {{ cTitle }} -->
        </a>
      </div>
      <div class="table">
        <tr>
          <td>文号</td>
          <td v-html="docno"></td>
        </tr>
        <tr>
          <td>发布机构</td>
          <td v-html="publisher"></td>
        </tr>
        <tr>
          <td>主题分类</td>
          <td v-html="cdesc"></td>
        </tr>
        <tr>
          <td>公文时效</td>
          <td v-html="validity"></td>
        </tr>
        <tr>
          <td>摘要</td>
          <td v-html="zc_doccontent" class="zhaiyao"></td>
        </tr>
      </div>
      <div class="info">
        <div class="department fl" style="margin-right: 5px">
          <a :href="link" v-html="sitedesc" target="_blank">
            <!-- {{ cBuMen }} -->
          </a>
        </div>
        <div class="date fl">
          {{ docpubtime.substring(0,10)}}
          <!-- <p v-html="cDate">
          {{ cDate }}
        </p> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "v-table-zc",
  components: {},
  props: {
    cNormalData: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {};
  },
  watch: {},
  computed: {
    // 链接
    link() {
      return this.cNormalData.docpuburl;
    },
    // 类型
    type() {
      return this.cNormalData.chnldesc;
    },
    // 标题
    title() {
      return this.cNormalData.zc_doctitle;
    },
    // 文号
    docno() {
      return this.cNormalData.docno;
    },
    // 发布机构
    publisher() {
      return this.cNormalData.publisher;
    },
    // 主题分类
    cdesc() {
      return this.cNormalData.cdesc;
    },
    // 文章时效
    validity() {
      return this.cNormalData.validity;
    },
    // 摘要
    zc_doccontent() {
      return this.cNormalData.zc_doccontent;
    },
    // 部门
    sitedesc() {
      return this.cNormalData.sitedesc;
    },
    // 日期
    docpubtime() {
      return this.cNormalData.docpubtime;
    },
  },
  methods: {},
  created() {},
  mounted() {},
};
</script>

<style lang='less' scoped>
.fl {
  float: left;
}
.clear {
  clear: both;
}
a {
  text-decoration: none;
  color: rgb(1, 82, 147);
  margin-left: 5px;
}
@media screen and (min-width: 751px) {
  .mobile {
    display: none;
  }
  .table_3 {
    display: block;
    width: 823px;
    // height: 210px;
    margin-bottom: 40px;

    .title {
      width: 823px;
      height: 30px;
      margin-bottom: 20px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      color: rgb(1, 82, 147);
      font-size: 18px;
      span {
        height: 20px;
        background-color: rgb(1, 82, 147);
        color: #ffffff;
        padding: 4px 10px 4px 10px;
      }
      a {
        white-space: nowrap;
      }
    }
    .table {
      width: 823px;
      // height: 145px;
      border: 1px solid rgb(204, 204, 204);
      .row {
        height: 40px;
        width: 823px;
        border-bottom: 1px solid rgb(204, 204, 204);
        .block {
          height: 40px;
          width: 400px !important;
          border-right: 1px solid rgb(204, 204, 204);
          font-size: 16px;
          line-height: 40px;
          .sign {
            width: 90px;
            height: 40px;
            // text-align-last: justify;
            padding-left: 10px;
            font-weight: bold;
            background-color: rgb(250, 250, 250);
          }
          .content {
            // height: 20px;
            width: 300px;
            // height: 40px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
      }
      .row2 {
        width: 823px;
        min-height: 40px;
        max-height: 80px;
        line-height: 28px;
        font-size: 16px;
        // padding: 10px;
        overflow: hidden;
        background-color: rgb(250, 250, 250);
        .sign {
          width: 80px;
          // padding-top: 10px;
          padding-left: 10px;
          // padding-bottom: 10px;
          text-align-last: justify;
          // min-height: 43px;
          // max-height: 63px;
          font-weight: bold;
        }
        .content {
          width: 723px;
          // padding-top: 10px;
          // padding-bottom: 10px;
          background-color: #ffffff;
          p {
            padding: 0;
            margin: 0;
            width: 723px;
            min-height: 40px;
            line-height: 28px;
            overflow: hidden;
            white-space: normal;
            text-overflow: ellipsis;
            overflow: hidden;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
          }
        }
      }
    }
    .info {
      height: 20px;

      margin-top: 10px;
      color: rgb(169, 169, 169);

      .date {
        color: rgb(169, 169, 169);
      }

      .department {
        a {
          color: rgb(169, 169, 169);
        }
        font-size: 16px;
      }
    }
  }
}
@media screen and (max-width: 750px) {
  @w: 7.5vw;

  .table_3 {
    display: none;
  }
  .mobile {
    display: block;
    width: 730 / @w;

    // height: 410 / @w;
    padding-left: 20 / @w;
    padding-bottom: 60 / @w;
    border-bottom: 15 / @w solid rgb(230, 230, 230);
    margin-bottom: 20 / @w;

    .title {
      width: 700 / @w;
      height: 50 / @w;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      color: rgb(1, 82, 147);
      margin-bottom: 10 / @w;
      // font-size: 16 / @w;
      line-height: 45 / @w;
      font-size: 18px;
      font-weight: bold;
      span {
        height: 20 / @w;
        background-color: rgb(1, 82, 147);
        color: #ffffff;
        padding: 4 / @w 10 / @w 4 / @w 10 / @w;
      }
      a {
        white-space: nowrap;
      }
    }
    .table {
      width: 700 / @w;
      // height: 145px;
      border: 1 / @w solid rgb(204, 204, 204);
      border-bottom: none;
      tr {
        width: 700 / @w;
        height: 40 / @w;
        line-height: 40 / @w;

        td {
          width: 530 / @w;
          border-bottom: 1 / @w solid rgb(204, 204, 204);
          padding-left: 15 / @w;
          padding-right: 15 / @w;
        }
        td:first-child {
          background-color: rgb(250, 250, 250);
          border-right: 1 / @w solid rgb(204, 204, 204);
          // border-top: 1 / @w solid rgb(204, 204, 204);
          width: 120 / @w;
          max-height: 120 / @w;
          text-align-last: justify;
          padding-left: 10 / @w;
          padding-right: 10 / @w;
        }

        .zhaiyao {
          overflow: hidden;
          display: -webkit-box;
          text-overflow: ellipsis;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 3;
        }
      }
    }
    .info {
      margin-top: 10 / @w;
      a {
        color: rgb(169, 169, 169);
      }
      color: rgb(169, 169, 169);
    }
  }
}
</style>